<div fxLayout>
  <main fxFlex style="padding: 0px; margin-bottom: 0">
    <picture>
      <source srcset="assets/images/demo/operations/operations.webp" type="image/webp" />
      <img src="assets/images/demo/operations/operations.svg" class="demo-ux-image" (load)="isImageLoaded = true" />
    </picture>

    <div class="demo-callout rules__intro-text" *ngIf="isImageLoaded">
      <ng-container *ngIf="userTrialConnectAccountCta$ | async as userTrialConnectAccountCta">
        <h2>Get more done with your team!</h2>
        <p class="notification__description">
          Keep your team in the loop with Operations. Manage cleaning, maintenance tasks, and more with automated task
          assignments based on reservation dates and other dependencies.
        </p>
        <p class="notification__description">
          Connect your {{ userTrialConnectAccountCta?.platformUi | titlecase }} account to import your listings into
          your Hospitable.com account and start sending automatic task reminders to your team!
        </p>

        <div class="rules__intro-buttons" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px">
          <button mat-flat-button (click)="clickedPrimaryCta(userTrialConnectAccountCta.connectAccountUrl)">
            Connect with {{ userTrialConnectAccountCta?.platformUi | titlecase }}
          </button>

          <a
            mat-flat-button
            class="button__secondary"
            (click)="
              clickedSecondaryCta(
                'https://my.hospitable.com/support-documentation/article/4616024-getting-started-with-operations'
              )
            ">
            Learn more
          </a>
        </div>
      </ng-container>
    </div>
  </main>
</div>
